var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input-field',{key:'date_of_birth',staticClass:"mb-min",attrs:{"color":_vm.color,"backgroundColor":"input-color-for-blue-background","iconColor":_vm.color,"placeholder":_vm.$t('sign_up.placeholders.date_of_birth'),"icon":"date_range","name":"date_of_birth","initial-value":_vm.value,"allow-initial-value-to-change-text-data":true,"disabled":true,"title":_vm.$t('user_profile.titles.datepicker')}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11715136","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/elements/DatePickerPreview.vue
// module id = iRUK
// module chunks = 0 1